import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/bd75479a05d033d29e61acbbb64ffc98.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#080C1E]/70 via-[#080C1E]/60 to-[#080C1E]" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center pt-20">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#C9A227]/10 border border-[#C9A227]/30 rounded-full mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-[#C9A227] animate-pulse inline-block"></span>
          <span className="text-[#C9A227] text-xs font-semibold tracking-widest uppercase">Espace Privé · Sport &amp; Business</span>
        </div>

        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img
            src="https://storage.readdy-site.link/project_files/88b042fa-1b1e-4828-a084-65a05e6769ac/242fee5f-76d2-4bf5-b968-77fd062724cd_IMG_20260126_015045_031.webp?v=f427f7850abf122c2fe0f72017d39364"
            alt="AD.NOVA.PRO"
            className="h-20 w-auto object-contain"
          />
        </div>

        {/* Tagline */}
        <h1 className="text-4xl md:text-6xl font-black text-white leading-tight mb-5 tracking-tight">
          Ton réseau.<br />
          <span className="text-[#C9A227]">Tes experts.</span><br />
          Ton projet.
        </h1>
        <p className="text-lg text-white/50 max-w-xl mx-auto mb-10 leading-relaxed">
          Le réseau privé dédié aux sportifs professionnels et semi-professionnels
          en reconversion vers l&apos;entrepreneuriat.
        </p>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/auth/signup"
            className="w-full sm:w-auto px-8 py-4 bg-[#C9A227] text-[#080C1E] font-black text-base rounded-xl hover:bg-[#D4B84A] transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-user-add-line text-lg"></i>
            Créer mon compte
          </Link>
          <Link
            to="/auth/signin"
            className="w-full sm:w-auto px-8 py-4 bg-white/[0.07] border border-white/20 text-white font-semibold text-base rounded-xl hover:bg-white/[0.12] transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-login-box-line text-lg"></i>
            J&apos;ai déjà un compte
          </Link>
        </div>

        {/* Social proof */}
        <div className="mt-12 flex items-center justify-center gap-6 flex-wrap">
          <div className="flex -space-x-2">
            {[
              'https://readdy.ai/api/search-image?query=professional%20portrait%20athletic%20man%2030s%20confident%20sporty%20dark%20background&width=60&height=60&seq=sp1&orientation=squarish',
              'https://readdy.ai/api/search-image?query=professional%20portrait%20athletic%20woman%2030s%20confident%20sporty%20dark%20background&width=60&height=60&seq=sp2&orientation=squarish',
              'https://readdy.ai/api/search-image?query=professional%20portrait%20athletic%20man%2040s%20confident%20dark%20background&width=60&height=60&seq=sp3&orientation=squarish',
              'https://readdy.ai/api/search-image?query=professional%20portrait%20athletic%20woman%2040s%20confident%20sporty%20dark%20background&width=60&height=60&seq=sp4&orientation=squarish',
            ].map((src, i) => (
              <div key={i} className="w-9 h-9 rounded-full border-2 border-[#080C1E] overflow-hidden ring-1 ring-[#C9A227]/30">
                <img src={src} alt="" className="w-full h-full object-cover object-top" />
              </div>
            ))}
          </div>
          <p className="text-sm text-white/40">
            Rejoignez <strong className="text-white/70">+120 sportifs</strong> déjà membres
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/30 text-xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
